import { render, staticRenderFns } from "./AdminPerformanceStats.vue?vue&type=template&id=7d1b51b4&scoped=true&"
import script from "./AdminPerformanceStats.vue?vue&type=script&lang=js&"
export * from "./AdminPerformanceStats.vue?vue&type=script&lang=js&"
import style0 from "./AdminPerformanceStats.vue?vue&type=style&index=0&id=7d1b51b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b51b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d1b51b4')) {
      api.createRecord('7d1b51b4', component.options)
    } else {
      api.reload('7d1b51b4', component.options)
    }
    module.hot.accept("./AdminPerformanceStats.vue?vue&type=template&id=7d1b51b4&scoped=true&", function () {
      api.rerender('7d1b51b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminPerformanceStats.vue"
export default component.exports